import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
const storagePrefix = environment.SESSION_STORAGE_PREFIX;
const jwt = new JwtHelperService();

type StorageKeys = 'USER_NAME';

export const appStorage = {
  //?TOKEN
  getDecodedToken() {
    const data: any = localStorage.getItem(`${storagePrefix}token`);
    return jwt.decodeToken(data);
  },

  getToken: (): string | null => { // Changed return type for accuracy
    // REMOVED JSON.parse()
    return localStorage.getItem(`${storagePrefix}token`);
  },
  setToken: (token: string) => {
    // REMOVED JSON.stringify()
    localStorage.setItem(`${storagePrefix}token`, token);
  },

  removeToken: () => {
    localStorage.removeItem(`${storagePrefix}token`);
  },

  //?ROLE
  getRole: (): string => {
    const data: any = localStorage.getItem(`${storagePrefix}role`);
    return JSON.parse(data) as string;
  },
  setRole: (role: string) => {
    localStorage.setItem(`${storagePrefix}role`, JSON.stringify(role));
  },

  clearAll: () => {
    localStorage.clear();
  },

  setData(data: any, key: StorageKeys) {
    localStorage.setItem(key, JSON.stringify(data));
  },

  getDate(key: StorageKeys) {
    const data: any = localStorage.getItem(key);
    return JSON.parse(data);
  },

  removeData(key: string) {
    localStorage.removeItem(key);
  },
};
